export default __webpack_public_path__ + "static/media/Airport.fb944601.jpeg";